import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/close-icon-2.svg'


const _hoisted_1 = { class: "fixed top-0 right-0 bottom-0 left-0 w-full h-screen flex items-center justify-center bg-black/40 z-[200]" }
const _hoisted_2 = { class: "w-[628px] -translate-y-0 p-5 rounded-primary-radius bg-[#FFFFFF]" }
const _hoisted_3 = { class: "flex items-center justify-between pb-[16px] border-b border-[#E3E1EA]" }
const _hoisted_4 = {
  key: 0,
  class: "text-[#ED857F] text-sm pt-1"
}
const _hoisted_5 = {
  key: 0,
  class: "flex w-full overflow-x-auto gap-1 mt-6 whitespace-nowrap scrollable-container"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "flex w-full overflow-x-auto gap-1 mt-6 whitespace-nowrap scrollable-container"
}
const _hoisted_8 = { class: "shrink-0 w-[123px] h-[123px]" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "mt-[24px] mb-5" }
const _hoisted_11 = {
  key: 0,
  class: "text-sm text-[#ED857F] mt-1"
}

import client from "@/utils/axios";
import { reactive, ref } from "vue";

type Props = {
  selectedInput: any;
  projectId: string | null | undefined;
};

type Emits = {
  (event: "toggleModal"): void;
  (event: "addTechnicalData", newData: any): void;
  (event: "refresh"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'TechnicalModal',
  props: {
    selectedInput: {},
    projectId: {}
  },
  emits: ["toggleModal", "addTechnicalData", "refresh"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const files = ref([]);

const inputTitle = ref(props.selectedInput ? props.selectedInput.value : "");

const imagePreviews = ref<string[]>([]);

const handleFileChange = (event: any) => {
  files.value = Array.from(event.target.files);
  imagePreviews.value = files.value.map((file: any) =>
    URL.createObjectURL(file)
  );
  errors.imageUpload = "";
};

const errors = reactive({
  inputTitle: "",
  imageUpload: "",
});

const validate = () => {
  let valid = true;
  errors.inputTitle = "";

  if (!inputTitle.value) {
    valid = false;
    errors.inputTitle = "This field is required!";
  } else if (inputTitle.value.toString().length > 48) {
    valid = false;
    errors.inputTitle = "Max 48 characters.";
  }
  if (!props.selectedInput.image) {
    if (files.value.length === 0) {
      valid = false;
      errors.imageUpload = "Image is required!";
    } else {
      valid = true;
      errors.imageUpload = "";
    }
  }

  return valid;
};

const onSubmit = async () => {
  if (!validate()) return;
  try {
    const formData = new FormData();
    formData.append("name", inputTitle.value);
    formData.append("order", props.selectedInput.order);

    files.value.forEach((file, index) => {
      formData.append(`file[${index}]`, file);
    });

    formData.append(
      "group",
      props.selectedInput.id ? props.selectedInput.id : -1
    );
    await client.post(
      `/projects/${props.projectId}/save-group-details`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    inputTitle.value = "";
    emits("toggleModal");
    emits("refresh");
  } catch (error) {
    console.error("Error:", error);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-primary-text-color text-xl leading-[32px] font-semibold tracking-[0.01rem]" }, " Bauabschnitt ", -1)),
        _createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleModal'))),
          class: "cursor-pointer",
          src: _imports_0,
          alt: "Close icon"
        })
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["mt-4", imagePreviews.value && imagePreviews.value.length ? 'mb-5' : 'mb-0'])
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "pb-[6px] text-base leading-[26px] tracking-[0.01rem] font-medium text-[#898790]" }, " Title ", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputTitle).value = $event)),
            type: "text",
            onInput: _cache[2] || (_cache[2] = ($event: any) => (errors.inputTitle = '')),
            placeholder: "Placeholder",
            class: _normalizeClass(["w-full p-3 rounded-primary-radius outline-none text-base text-primary-text-color font-normal tracking-[0.01rem] bg-transparent placeholder:text-[#898790]", 
              !errors.inputTitle
                ? 'border border-[#E3E1EA]'
                : 'border border-[#ED857F]'
            ])
          }, null, 34), [
            [_vModelText, inputTitle.value]
          ]),
          (errors.inputTitle)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errors.inputTitle), 1))
            : _createCommentVNode("", true)
        ], 2),
        (imagePreviews.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imagePreviews.value, (src, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "shrink-0 w-[123px] h-[123px]"
                }, [
                  _createElementVNode("img", {
                    src: src,
                    alt: "Uploaded image",
                    class: "shrink-0 object-cover w-[123px] h-[123px] rounded-md"
                  }, null, 8, _hoisted_6)
                ]))
              }), 128))
            ]))
          : (__props.selectedInput && __props.selectedInput.image)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: __props.selectedInput?.image,
                    alt: "Uploaded image",
                    class: "shrink-0 object-cover w-[123px] h-[123px] rounded-md"
                  }, null, 8, _hoisted_9)
                ])
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _cache[5] || (_cache[5] = _createElementVNode("label", {
            for: "file",
            class: "flex items-center gap-2 px-4 py-2 text-[#393840] font-medium rounded-md cursor-pointer transition border-2 border-[#393840] w-fit hover:bg-[#F9F8F6]"
          }, [
            _createElementVNode("svg", {
              width: "15",
              height: "16",
              viewBox: "0 0 15 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M1.40186 7.59852L6.57257 2.4278C8.11026 0.890114 10.6034 0.890114 12.1411 2.4278C13.6788 3.96549 13.6786 6.45872 12.1409 7.99641L6.17468 13.9626C5.14956 14.9877 3.48778 14.9876 2.46265 13.9625C1.43753 12.9373 1.43728 11.2755 2.4624 10.2503L8.42862 4.28413C8.94118 3.77156 9.77265 3.77156 10.2852 4.28413C10.7978 4.79669 10.7974 5.62752 10.2849 6.14008L5.11414 11.3108",
                stroke: "#393840",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ]),
            _createTextVNode(" Attach Image ")
          ], -1)),
          _createElementVNode("input", {
            multiple: "",
            class: "hidden",
            type: "file",
            id: "file",
            onChange: handleFileChange
          }, null, 32),
          (errors.imageUpload)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(errors.imageUpload), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", { class: "w-full flex items-center justify-end border-t border-black/10 pt-4" }, [
        _createElementVNode("button", {
          onClick: onSubmit,
          class: "w-[150px] bg-black rounded-primary-radius text-white py-3 text-base leading-[26px] tracking-[0.01rem] font-semibold"
        }, " Save ")
      ])
    ])
  ]))
}
}

})